import { nodeTypes } from 'app/service/constants';

export const isWrite = type => type === nodeTypes.WRITE;

export const isFilter = type => type === nodeTypes.FILTER;

export const isSearchOrWrite = type => type === nodeTypes.SEARCH_OR_WRITE;

export const isSearch = type => type === nodeTypes.SEARCH;

export const isRead = type => type === nodeTypes.READ;
